import localforage from 'localforage'

export const store = localforage.createInstance({
  name: 'import',
  driver: localforage.INDEXEDDB,
})

const key = 'blob'

export const importStorage = {
  setAudioBlob: (blob: Blob) => store.setItem(key, blob),
  getAudioBlob: () => store.getItem<Blob>(key),
  removeAudioBlob: () => store.removeItem(key),
}
